// extracted by mini-css-extract-plugin
export default {"campaignCard":"m7mQnb_","image":"kIu_QXp","text":"GmRRiBd","isOnlyOfType":"tbXcJFG","label":"kErO3uZ","icon":"fCLn0vl","copy":"hylgGAG"};